import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    templates: [],
    groupedTemplates: {},
    categories: [],
    selectedTemplate: null,

    // CRUD states
    createLoading: false,
    createRes: null,
    updateLoading: false,
    updateRes: null,
    deleteLoading: false,
    deleteRes: null,
    seedLoading: false,
    seedRes: null,
};

const reportTemplateSlice = createSlice({
    name: 'reportTemplate',
    initialState,
    reducers: {
        // Get templates
        getTemplatesRequest: (state) => {
            state.loading = true;
        },
        getTemplatesSuccess: (state, action) => {
            state.loading = false;
            state.templates = action.payload.data || [];
            state.groupedTemplates = action.payload.grouped || {};
            state.categories = action.payload.categories || [];
        },
        getTemplatesFailure: (state, action) => {
            state.loading = false;
        },

        // Get single template
        getTemplateRequest: (state) => {
            state.loading = true;
        },
        getTemplateSuccess: (state, action) => {
            state.loading = false;
            state.selectedTemplate = action.payload.data;
        },
        getTemplateFailure: (state, action) => {
            state.loading = false;
        },
        clearSelectedTemplate: (state) => {
            state.selectedTemplate = null;
        },

        // Create template
        createTemplateRequest: (state) => {
            state.createLoading = true;
        },
        createTemplateSuccess: (state, action) => {
            state.createLoading = false;
            state.createRes = action.payload;
        },
        createTemplateFailure: (state, action) => {
            state.createLoading = false;
            state.createRes = action.payload;
        },
        resetCreateTemplate: (state) => {
            state.createRes = null;
        },

        // Update template
        updateTemplateRequest: (state) => {
            state.updateLoading = true;
        },
        updateTemplateSuccess: (state, action) => {
            state.updateLoading = false;
            state.updateRes = action.payload;
        },
        updateTemplateFailure: (state, action) => {
            state.updateLoading = false;
            state.updateRes = action.payload;
        },
        resetUpdateTemplate: (state) => {
            state.updateRes = null;
        },

        // Delete template
        deleteTemplateRequest: (state) => {
            state.deleteLoading = true;
        },
        deleteTemplateSuccess: (state, action) => {
            state.deleteLoading = false;
            state.deleteRes = action.payload;
        },
        deleteTemplateFailure: (state, action) => {
            state.deleteLoading = false;
            state.deleteRes = action.payload;
        },
        resetDeleteTemplate: (state) => {
            state.deleteRes = null;
        },

        // Seed templates
        seedTemplatesRequest: (state) => {
            state.seedLoading = true;
        },
        seedTemplatesSuccess: (state, action) => {
            state.seedLoading = false;
            state.seedRes = action.payload;
        },
        seedTemplatesFailure: (state, action) => {
            state.seedLoading = false;
            state.seedRes = action.payload;
        },
        resetSeedTemplates: (state) => {
            state.seedRes = null;
        },
    },
});

export const {
    getTemplatesRequest,
    getTemplatesSuccess,
    getTemplatesFailure,
    getTemplateRequest,
    getTemplateSuccess,
    getTemplateFailure,
    clearSelectedTemplate,
    createTemplateRequest,
    createTemplateSuccess,
    createTemplateFailure,
    resetCreateTemplate,
    updateTemplateRequest,
    updateTemplateSuccess,
    updateTemplateFailure,
    resetUpdateTemplate,
    deleteTemplateRequest,
    deleteTemplateSuccess,
    deleteTemplateFailure,
    resetDeleteTemplate,
    seedTemplatesRequest,
    seedTemplatesSuccess,
    seedTemplatesFailure,
    resetSeedTemplates,
} = reportTemplateSlice.actions;

export default reportTemplateSlice.reducer;
